import { DOWNLOAD_PRICE_FILE, DOWNLOAD_PRICE_FILE_SUCCESS, DOWNLOAD_PRICE_FILE_ERROR, DOWNLOAD_PRICE_FILE_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const DownloadPriceType = (state = initialState, action) => {
  switch (action.type) {
    case DOWNLOAD_PRICE_FILE:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_PRICE_FILE_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case DOWNLOAD_PRICE_FILE_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case DOWNLOAD_PRICE_FILE_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default DownloadPriceType;
